export type RedactToken = { text: string; sensitive: boolean; conceptId: string };
export type RedactRound = { context: string; tokens: RedactToken[] };

const OPS = "act_obligations_ops";
const TRUST = "trustworthiness_eval";
const GPAI = "gpai_transparency";
const BAN = "act_prohibited";
const RAG = "generative_rag";

export const EPSO_AD8_AI_REDACT_DECK: readonly RedactRound[] = [
  {
    context:
      "Draft Article 26 serious-incident note from a law-enforcement deployer to a vendor (practice text):",
    tokens: [
      { text: "Incident class:", sensitive: false, conceptId: OPS },
      { text: "false match during a live operation", sensitive: false, conceptId: OPS },
      { text: "live target list and safe-house address", sensitive: true, conceptId: OPS },
      { text: "time window of the run", sensitive: false, conceptId: OPS },
    ],
  },
  {
    context: "Bias-correction ticket opened in a shared vendor portal:",
    tokens: [
      { text: "Need to check subgroup error rates", sensitive: false, conceptId: TRUST },
      {
        text: "attached: raw health and ethnicity columns for 12 000 people",
        sensitive: true,
        conceptId: TRUST,
      },
      { text: "legal basis still blank", sensitive: true, conceptId: TRUST },
      {
        text: "ask whether synthetic or anonymised data would suffice",
        sensitive: false,
        conceptId: TRUST,
      },
    ],
  },
  {
    context: "Draft public Article 53 training-content summary:",
    tokens: [
      { text: "Broad categories of text and image sources", sensitive: false, conceptId: GPAI },
      { text: "full weight files and optimiser states", sensitive: true, conceptId: GPAI },
      { text: "licensed-data share as a percentage range", sensitive: false, conceptId: GPAI },
      { text: "unpublished customer prompts used in eval", sensitive: true, conceptId: GPAI },
    ],
  },
  {
    context: "Biometric log extract proposed for a contractor debug session:",
    tokens: [
      { text: "anonymised match IDs", sensitive: false, conceptId: BAN },
      { text: "raw identity photographs", sensitive: true, conceptId: BAN },
      { text: "start and end timestamps of the query", sensitive: false, conceptId: BAN },
      { text: "home addresses linked to each face", sensitive: true, conceptId: BAN },
    ],
  },
  {
    context: "Public ticket about a retrieval failure:",
    tokens: [
      { text: "chunker window 512 tokens", sensitive: false, conceptId: RAG },
      {
        text: "retrieved paragraph containing a named official’s medical note",
        sensitive: true,
        conceptId: RAG,
      },
      { text: "index name in the test environment", sensitive: false, conceptId: RAG },
      { text: "national ID inside the pasted chunk", sensitive: true, conceptId: RAG },
    ],
  },
  {
    context: "FRIA notification draft to the market surveillance authority:",
    tokens: [
      { text: "intended purpose: benefits eligibility support", sensitive: false, conceptId: OPS },
      { text: "unrelated workers’ individual performance scores", sensitive: true, conceptId: OPS },
      { text: "oversight role of the case handler", sensitive: false, conceptId: OPS },
      { text: "complaint channel for affected persons", sensitive: false, conceptId: OPS },
    ],
  },
];
